import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postGenerateReportFromSelectedRecords = async (
  projectId,
  recordIds,
  generationParams
) => {
  const apiPath = `report/${projectId}/generate-report-from-records`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      recordIds,
      generationParams: { ...generationParams },
    },
  });

  const response = await axios(signedRequest);

  return response.data;
};
